<template>
  <div class="customer-status">
    <div
      class="customer-status-list"
      v-if="tijianDetail.id"
    >
      <div class="customer-status-title">
        客户体检状态
      </div>
      <div class="customer-status-item">
        <div class="customer-status-label">
          公众号状态
        </div>
        <div class="customer-status-content">
          {{ tijianDetail.bind_open_id_status | openStatus }}
        </div>
      </div>
      <div class="customer-status-item">
        <div class="customer-status-label">
          健康风险评估问卷
        </div>
        <div class="customer-status-content">
          {{ tijianDetail.tijian_evaluation_status | evalStatus }}
        </div>
      </div>
      <div class="customer-status-item">
        <div class="customer-status-label">
          定制套餐签字状态
        </div>
        <div class="customer-status-content">
          <span v-if="tijianDetail.tijian_sign_package_confirm_status === 0">{{ tijianDetail.tijian_sign_package_confirm_status | surveyStatus }}</span>
          <span v-if="tijianDetail.tijian_sign_package_confirm_status === 1">{{ tijianDetail.tijian_sign_package_confirm_status | surveyStatus }}</span>
        </div>
      </div>
      <div class="customer-status-item">
        <div class="customer-status-label">
          术前须知状态
        </div>
        <div class="customer-status-content">
          {{ tijianDetail.tijian_xuzhi_read_status | operationXuzhi }}
        </div>
      </div>
      <div
        class="customer-status-item"
        v-if="tijianDetail.service_car_number"
      >
        <div class="customer-status-label">
          停车服务
        </div>
        <div class="customer-status-content">
          {{ tijianDetail.service_car_number }}
        </div>
      </div>
      <div
        class="customer-status-item"
        v-if="tijianDetail.service_user_name"
      >
        <div class="customer-status-label">
          礼宾服务
        </div>
        <div class="customer-status-content">
          {{ tijianDetail.service_user_name }}
        </div>
      </div>
      <div class="customer-status-item">
        <div class="customer-status-label">
          满意度调查问卷
        </div>
        <div class="customer-status-content">
          {{ tijianDetail.tijian_survey_manyidu_status | myiStatus }}
        </div>
      </div>
      <div class="customer-status-item">
        <div class="customer-status-label">
          重大阳性状态
        </div>
        <div class="customer-status-content">
          {{ tijianDetail.tijian_zhongda_read_status | stateStatus }}
        </div>
      </div>
      <div class="customer-status-item">
        <div class="customer-status-label">
          体检报告状态
        </div>
        <div class="customer-status-content">
          {{ tijianDetail.tijian_report_read_status | stateStatus }}
        </div>
      </div>
      <div class="customer-status-item">
        <div class="customer-status-label">
          第1次随访状态
        </div>
        <div class="customer-status-content">
          {{ tijianDetail.tijian_visit_1st_read_status | visitStatus }}
        </div>
      </div>
      <div class="customer-status-item">
        <div class="customer-status-label">
          第2次随访状态
        </div>
        <div class="customer-status-content">
          {{ tijianDetail.tijian_visit_2nd_read_status | visitStatus }}
        </div>
      </div>
      <div class="customer-status-item">
        <div class="customer-status-label">
          第3次随访状态
        </div>
        <div class="customer-status-content">
          {{ tijianDetail.tijian_visit_3rd_read_status | visitStatus }}
        </div>
      </div>
      <div class="customer-status-item">
        <div class="customer-status-label">
          第4次随访状态
        </div>
        <div class="customer-status-content">
          {{ tijianDetail.tijian_visit_4th_read_status | visitStatus }}
        </div>
      </div>
    </div>

    <div
      class="customer-status-list"
      v-if="neijingDetail.id"
    >
      <div class="customer-status-title">
        客户内镜状态
      </div>
      <div class="customer-status-item">
        <div class="customer-status-label">
          公众号状态
        </div>
        <div class="customer-status-content">
          {{ neijingDetail.bind_open_id_status | openStatus }}
        </div>
      </div>
      <div
        class="customer-status-item"
        v-if="neijingDetail.history_report_url && neijingDetail.history_report_url.length !== 0"
      >
        <div class="customer-status-label">
          历史胃肠镜报告
        </div>
        <div class="customer-status-content">
          <div
            v-for="(item , i) in neijingDetail.history_report_url"
            :key="i"
            style="margin-right: 5px"
            class="demo-image__preview"
          >
            <el-image
              :src="item"
              :preview-src-list="neijingDetail.history_report_url"
              style="width: 80px; height: 80px"
            />
          </div>
        </div>
      </div>
      <div
        class="customer-status-item"
        v-else
      >
        <div class="customer-status-label">
          历史胃肠镜报告
        </div>
        <div class="customer-status-content">
          暂无
        </div>
      </div>
      <div class="customer-status-item">
        <div class="customer-status-label">
          评估小结状态
        </div>
        <div class="customer-status-content">
          {{ neijingDetail.summary_read_time ? `已读 ${neijingDetail.summary_read_time}` : '未读' }}
        </div>
      </div>
      <div
        class="customer-status-item"
        v-if="neijingDetail.hesuan_report_url && neijingDetail.hesuan_report_url.length !== 0 && neijingDetail.hesuan_report_url[0] !== ''"
      >
        <div class="customer-status-label">
          核酸报告状态
        </div>
        <div class="customer-status-content">
          <div
            v-for="(item , i) in neijingDetail.hesuan_report_url"
            :key="i"
            style="margin-right: 5px"
            class="demo-image__preview"
          >
            <el-image
              :src="item"
              :preview-src-list="neijingDetail.hesuan_report_url"
              style="width: 80px; height: 80px"
            />
          </div>
        </div>
      </div>
      <!-- <div
        class="customer-status-item"
        v-else
      >
        <div class="customer-status-label">
          历史胃肠镜报告
        </div>
        <div class="customer-status-content">
          未传
        </div>
      </div> -->

      <div class="customer-status-item">
        <div class="customer-status-label">
          {{ neijingDetail.his_package_name }}检查前饮食提醒
        </div>
        <div class="customer-status-content">
          {{ neijingDetail.yinshi_read_status | operationXuzhi }}
        </div>
      </div>
      <div class="customer-status-item">
        <div class="customer-status-label">
          无痛{{ neijingDetail.his_package_name }}检前告知书
        </div>
        <div class="customer-status-content">
          {{ neijingDetail.gaozhishu_read_status | operationXuzhi }}
        </div>
      </div>
      <div
        class="customer-status-item"
        v-if="neijingDetail.his_package_id !== 1"
      >
        <div class="customer-status-label">
          泻药服用方法
        </div>
        <div class="customer-status-content">
          {{ neijingDetail.xieyao_read_status | operationXuzhi }}
        </div>
      </div>
      <div class="customer-status-item">
        <div class="customer-status-label">
          术前须知状态
        </div>
        <div class="customer-status-content">
          {{ neijingDetail.operation_xuzhi_read_status | operationXuzhi }}
        </div>
      </div>
      <!-- <div class="customer-status-item">
        <div class="customer-status-label">
          停药指导状态
        </div>
        <div class="customer-status-content">
          {{ neijingDetail.stop_drug_read_status | stateStatus }}
        </div>
      </div> -->
      <div class="customer-status-item">
        <div class="customer-status-label">
          内镜报告状态
        </div>
        <div class="customer-status-content">
          {{ neijingDetail.operation_report_read_status | reportStatus }}
        </div>
      </div>
      <div class="customer-status-item">
        <div class="customer-status-label">
          健康指导状态
        </div>
        <div class="customer-status-content">
          {{ neijingDetail.health_guide_status | stateStatus }}
        </div>
      </div>
      <div class="customer-status-item">
        <div class="customer-status-label">
          24h随访小结状态
        </div>
        <div class="customer-status-content">
          {{ neijingDetail.visit_24h_status | visitStatus }}
        </div>
      </div>
      <div class="customer-status-item">
        <div class="customer-status-label">
          病理报告状态
        </div>
        <div class="customer-status-content">
          {{ neijingDetail.bingli_report_read_status | reportStatus }}
        </div>
      </div>
      <div class="customer-status-item">
        <div class="customer-status-label">
          满意度调查状态
        </div>
        <div class="customer-status-content">
          {{ neijingDetail.neijing_survey_manyidu_status == 1 ? '已填写' : '未填写' }}
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import menZhenService from "@/apis/menZhen/index.js";

export default {
  data() {
    return {
      neijingDetail: {},
      tijianDetail: {},
    };
  },
  created() {
    const { query } = this.$route;
    if (query.menzhen_work_id_neijing) {
      this.workDetail({
        work_id: query.menzhen_work_id_neijing,
        type: "neijing",
      });
    }
    if (query.menzhen_work_id_tijian) {
      this.workDetail({
        work_id: query.menzhen_work_id_tijian,
        type: "tijian",
      });
    }
  },
  filters: {
    customerStatus(status) {
      const evelMap = {
        1: "新客户",
        2: "历史客户",
      };
      return evelMap[status];
    },
    openStatus(status) {
      const openMap = {
        0: "未绑定",
        1: "已绑定",
      };
      return openMap[status];
    },
    surveyStatus(status) {
      const evelMap = {
        0: "未签字",
        1: "已签字",
      };
      return evelMap[status];
    },
    stateStatus(status) {
      const evelMap = {
        0: "未读",
        1: "已读",
      };
      return evelMap[status];
    },
    visitStatus(status) {
      const evelMap = {
        0: "未回访",
        1: "已回访",
      };
      return evelMap[status];
    },
    reportStatus(status) {
      const evelMap = {
        0: "未读",
        1: "已读",
      };
      return evelMap[status];
    },
    tjStatus(status) {
      const evelMap = {
        0: "否",
        1: "是",
      };
      return evelMap[status];
    },
    operationXuzhi(status) {
      const evelMap = {
        0: "未读",
        1: "已读",
      };
      return evelMap[status];
    },
    evalStatus(status) {
      const evelMap = {
        0: "待评估（未填写）",
        1: "待评估（已填写）",
        2: "评估通过",
        3: "评估不通过",
      };
      return evelMap[status];
    },
    myiStatus(status) {
      const evelMap = {
        0: "未填写",
        1: "已填写",
      };
      return evelMap[status];
    },
    bookStatus(status) {
      const evelMap = {
        0: "待预约",
        1: "已预约",
        2: "已完成",
        3: "已取消",
      };
      return evelMap[status];
    },
  },
  methods: {
    workDetail({ work_id, type }) {
      const params = {
        work_id,
      };
      menZhenService.workDetail(params).then((res) => {
        if (type === "neijing") {
          this.neijingDetail = res;
        } else {
          this.tijianDetail = res;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.customer-status {
}
.customer-status-list {
  padding: 20px;
}
.customer-status-title {
  font-size: 18px;
  font-weight: 600;
}
.customer-status-item {
  display: flex;
  .customer-status-label {
    width: 150px;
  }
  .customer-status-content {
  }
}
</style>